// Copyright (c) Move Closer 2022.
import { Injectable } from '@movecloser/front-core'

import { ITabsService, TabItem } from './contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Injectable()
export class TabsService<Item extends TabItem> implements ITabsService<Item> {
  protected _tabs: Item[] = []

  /**
   * @inheritDoc
   */
  public addTabs (tabs: Item[], overrides: boolean = false): void {
    if (overrides) {
      this._tabs = tabs
    } else {
      this._tabs.push(...tabs)
    }
  }

  /**
   * @inheritDoc
   */
  public getTabs (): Item[] {
    return this._tabs
  }

  /**
   * Returns the tab by its value
   */
  protected getTabByValue (value: string): Item | undefined {
    return this._tabs.find((item) => item.value === value)
  }
}
